export default __webpack_public_path__ + "static/media/data-img.6cd81d52.svg";